import { StateStore } from "./StateStore";
import { Actions } from "../Actions/Actions";
import { IbizaWebChatPageProps } from "./../Views/IbizaWebChatPage";

import { PageStatus } from "../Controllers/WebChatController";

/**
 * Utility methods to map store + actions to component props.
 */
export class StateStoreUtility {
    public static mapStateAndDispatchToProps(state: StateStore, actions: Actions): IbizaWebChatPageProps {
        return {
            pageStatus: new PageStatus(state.pageStatus),
            pageMessage: state.pageMessage,
            botId: state.botId,
            location: state.location,
            webChatToken: state.webChatToken,
            onStartNewConversation: actions.onWebChatNewConversation
        };
    }
}



// WEBPACK FOOTER //
// ./Client/v4/Store/StateStoreUtility.ts